import { assert } from '@varos/util-typescript';
import { ReportingLoaderBaseConfig } from '../../../../../base';
import { ShortcutListAggregate } from './shortcutListModel';
import { ShortcutLoader } from './shortcutListInterface';

export function createShortcutLoader(config: ReportingLoaderBaseConfig): ShortcutLoader {
    const { repository } = config;

    return {
        useLoad(context, props): ShortcutListAggregate {
            // Use component repository to fetch components
            const componentQuery = repository.research.component.useFind(
                context,
                {},
                { suspense: true }
            );
            assert(componentQuery.status === 'success', 'expected suspense');

            return {
                components: componentQuery.data,
            };
        },
    };
}
